import { api } from "@/lib/api";

export const fmtCount = (n) => (n >= 1e6 ? (n / 1e6).toFixed(1) + "M" : n >= 1e3 ? (n / 1e3).toFixed(1) + "K" : String(n || 0));
export const FILTERS = [
  ["none", "Normal", "none"], ["vivid", "Vivid", "saturate(1.45) contrast(1.08)"], ["mono", "Mono", "grayscale(1)"],
  ["fade", "Fade", "contrast(.85) brightness(1.04) saturate(.75)"], ["warm", "Warm", "sepia(.25) saturate(1.2)"],
  ["cool", "Cool", "hue-rotate(15deg) saturate(1.1)"], ["retro", "Retro", "sepia(.9)"],
];

export async function uploadVibe(file, opts, onProgress) {
  const fd = new FormData(); fd.append("size", file.size); fd.append("mime", file.type || "video/mp4");
  const { data } = await api.post("/vibe/uploads", fd);
  let off = 0;
  while (off < file.size) {
    const part = file.slice(off, off + data.chunk_size);
    let tries = 0, r;
    for (;;) {
      try { r = await api.put(`/vibe/uploads/${data.upload_id}/chunk?offset=${off}`, part, { headers: { "Content-Type": "application/octet-stream" }, timeout: 120000 }); break; }
      catch (e) { if (++tries > 3 || e?.response?.status < 500) throw e; await new Promise((s) => setTimeout(s, 1500 * tries)); }
    }
    off = r.data.received;
    onProgress(off / file.size);
  }
  return (await api.post(`/vibe/uploads/${data.upload_id}/finish`, opts)).data.video;
}

export async function shareVideo(v) {
  const url = `${window.location.origin}/vibe/v/${v.id}`;
  api.post(`/vibe/videos/${v.id}/share`).catch(() => {});
  if (navigator.share) {
    try { await navigator.share({ title: "JixxeoVibe", text: v.caption || `Watch @${v.creator?.username} on JixxeoVibe`, url }); return "shared"; }
    catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  return "fallback";
}
